export default {"src":"/_next/static/media/logo.ad70e3af.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};